import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Dropdown, Dimmer } from "semantic-ui-react";
import FiltersIcon from "../../icons/FiltersIcon";
import ShareIcon from "../../icons/ShareIcon";
import SpreadsheetIcon from "../../icons/SpreadsheetIcon";
import LeaveIcon from "../../icons/LeaveIcon";
import EnterIcon from "../../icons/EnterIcon";
import DownloadIcon from "../../icons/DownloadIcon";
import SRHHeader from "./../index";
import { HeaderLeft, HeaderCenter, HeaderRight, HeaderTab, Logo, Title, Breadcrumb, DebrieferIcon, HeaderButton } from "./style.js";
import logo from "./../../../assets/img/logo/logo-white.png";
import { userOperations } from "./../../../redux/user";
import { summaryReportOperations } from "./../../../redux/summaryReport";
import { summaryReportTreeOperations } from "./../../../redux/summaryReportTree";
import SwitchReport from "./components/SwitchReport";
import ShareReport from "./components/ShareReport";
import moment from "moment";
import ReactGA from "react-ga";
import defaultTheme from "react-treebeard/lib/themes/default";
import Snackbar from "../../Snackbar";
import { navActions } from "./../../../redux/nav";
import clsx from 'clsx';

ReactGA.initialize("UA-52754256-15");

class SummaryReportHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      shareOpen: false,
      shareReportData: {},
    };
    this.download = this.download.bind(this);
    this.print = this.print.bind(this);
    this.signOut = this.signOut.bind(this);
    this.signIn = this.signIn.bind(this);
    this.shareOpen = this.shareOpen.bind(this);
    this.shareClose = this.shareClose.bind(this);
    this.toggleSettings = this.toggleSettings.bind(this);
    this.toggleDebrief = this.toggleDebrief.bind(this);
  }

  shareOpen() {
    this.setState({
      shareOpen: true
    })
  }

  shareClose(message) {
    const { dispatch } = this.props;
    this.setState({
      shareOpen: false,
    })
    dispatch(navActions.setSnackbarOptions({ message }));
  }

  toggleSettings() {
    const { nav } = this.props;
    nav.settingsOpen
      ? this.props.dispatch(navActions.closeSettings())
      : this.props.dispatch(navActions.openSettings())
  }

  toggleDebrief() {
    const { nav } = this.props;
    nav.debriefOpen
      ? this.props.dispatch(navActions.closeDebrief())
      : this.props.dispatch(navActions.openDebrief())

  }

  download() {
    const { datasetName, survey, configuration, surveyPeriod } = this.props.summaryReport;
    const { unit, landscape, filters, dispatch } = this.props;
    
    let fileNamePrefix = configuration.survey_type ? configuration.survey_type : survey;

    const filename = filters.count < 0
    ? `${fileNamePrefix}_Summary_Report_${datasetName}${unit ? `_${unit}` : ""}_${surveyPeriod}_${moment().format("MMDDYYYY")}.pdf`.replace(/[\s,_\/\\]+/g, "_")
    : `${fileNamePrefix}_Summary_Report_${filters.summary.replace(' ', '_')}${unit ? `_${unit}` : ""}_${surveyPeriod}_${moment().format("MMDDYYYY")}.pdf`.replace(/[\s,_\/\\]+/g, "_")

    if (unit) {
      ReactGA.event({
        category: datasetName,
        action: "save_unit_report",
        label: filename,
      });
    } else {
      ReactGA.event({
        category: datasetName,
        action: "save_hospital_report",
        label: filename,
      });
    }

    const oldIframe = document.getElementById("downloadIFrame");
    if (oldIframe) {
      oldIframe.remove();
    }

    const iframe = document.createElement("iframe");
    iframe.name = "downloadFrame";
    iframe.id = "downloadIFrame";
    iframe.style.display = "none";
    iframe.src = "";
    document.body.appendChild(iframe);

    const oldForm = document.getElementById("form");
    if (oldForm) {
      oldForm.remove();
    }

    const form = document.createElement("form");
    form.id = "form";
    form.method = "post";
    form.action = `https://reports.safeandreliablecare.com/api/pdf?orientation=${landscape ? "landscape" : "portrait"
      }`;
    form.target = "downloadFrame";
    document.body.appendChild(form);

    const filenameInput = document.createElement("input");
    filenameInput.type = "hidden";
    filenameInput.name = "filename";
    filenameInput.value = filename;
    form.appendChild(filenameInput);

    const htmlInput = document.createElement("input");
    htmlInput.type = "hidden";
    htmlInput.name = "html";

    //create an extra style element for print/pdf related styles
    const style = document.createElement('style');
    document.getElementsByTagName('head')[0].appendChild(style);
    style.type = 'text/css';
    style.appendChild(document.createTextNode('.hide { display: none !important}'));

    htmlInput.value = document.documentElement.innerHTML.replace(/\/static\//g, window.location.protocol === "https:" ? `https://${window.location.host}/static/` : `https://reports.us.safeandreliablecare.com/static/`);

    form.appendChild(htmlInput);

    //remove style element
    style.remove();

    form.submit();
    dispatch(navActions.setSnackbarOptions({ message: "Downloading report" }));
  }

  print() {
    const { datasetName, survey } = this.props.summaryReport;
    const { unit } = this.props;
    ReactGA.event({
      category: datasetName,
      action: "print_report",
      label: `${survey}_Summary_Report_${datasetName}${unit ? `_${unit}` : ""}_${moment().format("MMDDYYYY")}.pdf`,
    });
    window.print();
  }

  signOut() {
    this.props.dispatch(userOperations.signOut());
    this.props.dispatch(summaryReportOperations.clear());
    this.props.dispatch(summaryReportTreeOperations.clear());
  }

  signIn() {
    this.props.history.push(`/sign-in?referrer=${window.location.pathname}${window.location.search ? `?${window.location.search}` : ''}`);
  }

  handleClickOpen = () => {
    this.setState({
      open: true,
    });
  };

  handleClose = value => {
    this.setState({
      open: false,
    });
  };

  render() {
    const { breadcrumbs, units, ready, summaryReport, reportSelect, summaryReportTree, sharedSummaryReport, user, noReport, nav } = this.props;
    const datasetUnitName =
      summaryReport && summaryReport.datasetUnitNamePlural ? summaryReport.datasetUnitNamePlural : "Work Settings";
    defaultTheme.node = { activeLink: { color: "red" } };
    const view = (!sharedSummaryReport && (reportSelect === "tree" || (noReport && summaryReportTree.length > 0))) ? "tree" : "dropdown";
    const isLoggedIn = user && user.isLoggedIn;

    return (
      <SRHHeader>
        <Snackbar />
        {view === "tree" && (
          <HeaderLeft>
            <HeaderTab style={{ zIndex: "2" }}>
              <Logo className="logo">
                <img src={logo} alt="" />
              </Logo>
              <Title className="add-background">
                Survey <br /> Results
              </Title>
            </HeaderTab>
            {breadcrumbs &&
              breadcrumbs.length > 0 && (
                <HeaderTab style={{ zIndex: "1" }}>
                  <Breadcrumb key="breadcrumb-1">{breadcrumbs[0]}</Breadcrumb>
                </HeaderTab>
              )}
            {ready && (
              <HeaderButton onClick={this.handleClickOpen} className="select-switch-report">
                {noReport ? "Select report" : "Switch report"}
              </HeaderButton>
            )}
            {summaryReportTree.length > 0 && (
              <SwitchReport
                open={this.state.open}
                onClose={this.handleClose}
                summaryReportTree={summaryReportTree}
                currentReport={summaryReport}
                user={user}
              />
            )}
            <ShareReport open={this.state.shareOpen} onClose={this.shareClose} report={summaryReport} />
          </HeaderLeft>
        )}
        {view === "dropdown" && (
          <HeaderLeft>
            <HeaderTab style={{ zIndex: "2" }}>
              <Logo className="logo">
                <img src={logo} alt="" />
              </Logo>
              <Title className="add-background">
                Survey <br /> Results
              </Title>
            </HeaderTab>
            {breadcrumbs &&
              breadcrumbs.length > 0 && (
                <HeaderTab style={{ zIndex: "1" }}>
                  <Breadcrumb key="breadcrumb-1">{breadcrumbs[0]}</Breadcrumb>
                </HeaderTab>
              )}
            {breadcrumbs &&
              breadcrumbs.length > 1 &&
              (units.length > 1 && ready ? (
                <Breadcrumb key="breadcrumb-2" style={{ paddingLeft: "30px", zIndex: 1000 }}>
                  <Dropdown
                    search
                    selection
                    options={units}
                    value={breadcrumbs[1]}
                    onChange={(event, data) => this.props.setUnit(data.value)}
                  />
                </Breadcrumb>
              ) : breadcrumbs[1] === "all" ? (
                <Breadcrumb key="breadcrumb-2">All Surveyed {datasetUnitName}</Breadcrumb>
              ) : (
                <Breadcrumb key="breadcrumb-2">{breadcrumbs[1]}</Breadcrumb>
              ))}
          </HeaderLeft>
        )}
        <HeaderCenter />
        <Dimmer.Dimmable as={HeaderRight} dimmed={!ready}>
          {/* <Dimmer as={DimmerStyle} active={!ready} /> */}

          {ready && !noReport && (
            <HeaderButton className={clsx('settings', nav.settingsOpen && 'active')} onClick={this.toggleSettings}>
              <FiltersIcon />
            </HeaderButton>
          )}

          {ready && !noReport && summaryReport.enableDebriefer && isLoggedIn && (
            <HeaderButton className={clsx('debriefs', nav.debriefOpen && 'active')} onClick={this.toggleDebrief}>
              <DebrieferIcon />
              <i aria-hidden="true" className="debriefer-icon"></i>
            </HeaderButton>
          )}

          {view == "tree" && user && user.reportSettings && user.reportSettings.canShare === "true" && ready && !noReport && (
            <HeaderButton onClick={this.shareOpen} startIcon={<ShareIcon />}>
              Share
            </HeaderButton>
          )}

          {/* {ready && !noReport && (
            <HeaderButton onClick={() => console.log('Export!')} startIcon={<SpreadsheetIcon />}>
              Export Data
            </HeaderButton>
          )} */}

          {ready &&
            !noReport &&
            !summaryReport.configuration.disable_download &&
            (summaryReport.configuration.old_download_button ? (
              <HeaderButton onClick={this.download}>
                <DownloadIcon />
              </HeaderButton>
            ) : (
              <HeaderButton className="orange-download-button" onClick={this.download} startIcon={<DownloadIcon />}>
                Download/Print Report
              </HeaderButton>
            ))
          }
          {isLoggedIn && (
            <HeaderButton onClick={this.signOut} startIcon={<LeaveIcon />}>
              Sign Out
            </HeaderButton>
          )}
          {!isLoggedIn && summaryReport && summaryReport.enableDebriefer && (
            <HeaderButton onClick={this.signIn} startIcon={<EnterIcon />}>
              Sign In
            </HeaderButton>
          )}
        </Dimmer.Dimmable>
      </SRHHeader>
    );
  }
}

export default connect(store => {
  return {
    nav: store.nav
  };
})(withRouter(SummaryReportHeader));


// WEBPACK FOOTER //
// ./src/components/SRHHeaders/SummaryReportHeader/index.jsx